import { render, staticRenderFns } from "./UiEditorInspectorContent.vue?vue&type=template&id=69ba051c"
import script from "./UiEditorInspectorContent.vue?vue&type=script&lang=js"
export * from "./UiEditorInspectorContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports